export default "__VITE_ASSET__85f1bc7b__"